import { useState } from "react";
import { ArrowRight, ChevronDown } from "lucide-react";
import { Reveal } from "./Reveal";

const INITIAL_ARTICLE_COUNT = 6;

export function ArticlesSection({ articles, onOpenArticle }) {
  const [showAll, setShowAll] = useState(false);
  const visibleArticles = showAll ? articles : articles.slice(0, INITIAL_ARTICLE_COUNT);
  return (
    <section className="section articles-section" id="articles">
      <div className="container">
        <Reveal>
          <div className="section-label"><span className="chapter-no">05</span>Common symptoms</div>
          <div className="section-head"><h2>Know the symptoms, act early.</h2><p>Short guides to common urology concerns, written for patients.</p></div>
        </Reveal>
        <div className="articles-list">
          {visibleArticles.map((article, index) => (
            <Reveal key={article.id || article.title} delay={0.03}>
              <button className="article-row" data-testid={`article-row-${index}`} onClick={() => onOpenArticle(article)}>
                <span className="card-index">{String(index + 1).padStart(2, "0")}</span>
                <span className="article-row-title">{article.title}</span>
                <ArrowRight size={17} />
              </button>
            </Reveal>
          ))}
        </div>
        {articles.length > INITIAL_ARTICLE_COUNT && (
          <button className={`faq-more-toggle ${showAll ? "open" : ""}`} data-testid="articles-show-all-toggle" onClick={() => setShowAll(!showAll)}>
            <span>{showAll ? "Show fewer guides" : "View all symptom guides"}</span><ChevronDown size={16} />
          </button>
        )}
      </div>
    </section>
  );
}
